export function humanizeDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (isNaN(diffInSeconds)) return "";

  if (diffInSeconds < 60) {
    return `${diffInSeconds} seconds ago`;
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days !== 1 ? "s" : ""} ago`;
  } else {
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }
}

/**
 * Formats a date to YYYY-MM-DD format
 * @param {Date} date - The date to format
 * @returns {string} - Formatted date string
 */
export function formatDate(date) {
  if (!date) {
    console.error("No date provided to formatDate");
    date = new Date();
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Formats a date to "YYYY - Quarter Q - Month - WeekW" format
 * @param {Date|string} dateInput - The date to format
 * @returns {string} - Formatted date string (e.g., "2025 - Quarter 4 - December - Week51")
 */
export function formatQuarterlyWeek(dateInput) {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  const month = date.toLocaleString("en-US", { month: "long" });

  // Calculate week number of the year
  const firstDayOfYear = new Date(year, 0, 1);
  const daysSinceFirstDay = Math.floor(
    (date - firstDayOfYear) / (24 * 60 * 60 * 1000),
  );
  const weekNumber = Math.ceil(
    (daysSinceFirstDay + firstDayOfYear.getDay() + 1) / 7,
  );

  return `${year} - Quarter ${quarter} - ${month} - Week ${weekNumber}`;
}
